const arrayOrEmpty = (array) => array || []

export const take = (array, n) => array.slice(0, n)

export const split = (array, n) => [array.slice(0, n), array.slice(n)]

export const removeElementFromArray = (array, element) => (array || []).filter((el) => el !== element)

export const flat = (array) => array.reduce((acc, val) => acc.concat(val), [])

export const head = (array) => arrayOrEmpty(array)[0]

export const toggle = (array, toToggle) => {
  array = arrayOrEmpty(array)
  const index = array.indexOf(toToggle)

  if (index === -1) {
    return array.concat(toToggle)
  } else {
    return array.filter((x) => x !== toToggle)
  }
}

export const intersection = (array1, array2) =>
  arrayOrEmpty(array1).filter((value) => arrayOrEmpty(array2).indexOf(value) !== -1)

export const insertAt = (position, array, item) =>
  array.reduce((acc, v, idx) => (idx === position ? acc.concat([item, v]) : acc.concat([v])), [])

export const exists = (array) => (value) => array.indexOf(value) > -1

export const unique = (array) => array.reduce((acc, item) => (!acc.includes(item) ? acc.concat([item]) : acc), [])
